export default "__VITE_ASSET__a627e982__"